import React from 'react';

import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import DialogPaper from '../DialogPaper';

import * as RewardCardService from '../../api/rewardCardService';
import RedeemedRewardCard from '../Card/RedeemedRewardCard';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  grow: {
    flexGrow: 1,
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  toolbar: {
    height: 30,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
  },
  box: {
    flex: 1,
    display: 'flex',
  },
  close: {
    marginRight: 'auto',
  },
  actions: {
    marginLeft: 'auto',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  subTitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing(4),
  },
  closeIcon: {
    color: theme.palette.common.black,
  },
  selectedMerchantText: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    textAlign: 'left',
  },
  unselectedMerchantText: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'left',
  },
  homeContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(),
    marginTop: theme.spacing(4),
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 1)',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4),
  },

  listItemContainer: {
    marginLeft: 0,
    transition: 'none !important',
    backgroundColor: 'inherit !important',
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  redeemedRewardCardList: RewardCardService.RewardCard[];
};

export default function ViewMoreHistoryDialog({
  onClose,
  open,
  redeemedRewardCardList,
}: Props) {
  const classes = useStyles();

  const handleClose = () => {
    if (onClose) {
      onClose({}, 'backdropClick');
    }
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      PaperComponent={DialogPaper}
    >
      <div className={classes.toolbar}>
        <div className={classes.homeContainer}>
          <Typography variant="h4" className={classes.title}>
            History
          </Typography>
        </div>
        <IconButton onClick={handleClose}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </div>
      <Grid item xs={12} className={classes.root}>
        <RedeemedRewardCard rewardCardList={redeemedRewardCardList} />
      </Grid>
    </Dialog>
  );
}
